<template>
    <div>
        <slot/>
    </div>
</template>

<script>
// import Layout from './Layout'

export default {
    components:{
        // Layout
    }

}
</script>

<style>

</style>
